import type { Dispatch } from 'redux';

import { actionUpdateJobLocationId } from 'src/app/state/modules/formData/jobLocationId';
import { actionUpdateJobLocationCountry } from 'src/app/state/modules/session/jobLocationCountry';
import { actionUpdateJobLocationDisplayDescription } from 'src/app/state/modules/session/jobLocationDisplayDescription';
import { actionUpdateJobLocationText } from 'src/app/state/modules/session/jobLocationText';

type Location = {
  id?: string;
  country?: string;
  displayDescription?: string;
  description: string;
};

export const dispatchJobLocationActions = (
  dispatch: Dispatch,
  location?: Location,
) => {
  if (location?.id) {
    dispatch(
      actionUpdateJobLocationCountry(location.country?.toLowerCase() ?? ''),
    ); // redux store doesn't support undefined
    dispatch(
      actionUpdateJobLocationDisplayDescription(
        location.displayDescription ?? '',
      ),
    );
    dispatch(actionUpdateJobLocationId(location.id));
    dispatch(actionUpdateJobLocationText(location.description));
  }
};
